export default "export { Tabs } from './Tabs';\n";